import { ethers } from "ethers";
import OutputI from "../../../interfaces/Output";
import fetchCurrentGold from "../fetch-current-gold";
import fetchHighestAuctionBid from "../fetch-highest-auction-bid";
import fetchUserAuctionBid from "../fetch-user-auction-bid";

import ContractIdentifiers from "../../../constants/contractIdentifiers";
import getContractInstance from "../utils/getContractInstance";

/**
 * @TODO - Run auction tx
 * @param provider - A Web3Provider signed by the user's connected wallet.
 * @returns The new amount of gold after bidding.
 */
const placeAuctionBid = async (
    provider: ethers.providers.Web3Provider,
    bid: number
): Promise<OutputI<{
    fetchCurrentGoldResult: number,
    fetchHighestBid: number,
    fetchHighest: number
}>> => {
    try {
        // Do auction stuff here...
        let evSacrificer = await getContractInstance(provider, ContractIdentifiers.app.EternalVikingsSacrificer);
        let tx = await evSacrificer.connect(await provider.getSigner()).enterAuction(2, ethers.utils.parseEther(bid.toString()));
        await tx.wait();

        // Fetching updated gold amount in wallet.
        const fetchCurrentGoldResult = await fetchCurrentGold(provider);        
        if(fetchCurrentGoldResult.err) throw new Error(fetchCurrentGoldResult.msg);
        if (fetchCurrentGoldResult.output === undefined) throw new Error("Current gold amount is undefined");

        const fetchHighestBid = await fetchHighestAuctionBid(provider);
        if(fetchHighestBid.err) throw new Error(fetchHighestBid.msg);
        if (fetchHighestBid.output === undefined) throw new Error("fetchHighestBid amount is undefined");

        const fetchHighest = await fetchUserAuctionBid(provider);
        if(fetchHighest.err) throw new Error(fetchHighest.msg);
        if (fetchHighest.output === undefined) throw new Error("fetchHighest amount is undefined");


        return {err: false, output: {
            fetchCurrentGoldResult: fetchCurrentGoldResult.output,
            fetchHighestBid: fetchHighestBid.output,
            fetchHighest: fetchHighest.output,
        }};
    } catch (error) {
        return {err: true, msg: `claim-gold/index.ts::claimGold():: Failed to claim gold! || \n${error}`};
    }
}

export default placeAuctionBid;